import { ComponentProps } from "react"

import { twMerge } from "tailwind-merge"

import style from "./Input.module.scss"
import { FieldError } from "~/src/components/FieldError"

export interface InputError {
  message?: string
}

export type InputProps = { error?: InputError | boolean } & ComponentProps<"input">

export function Input(props: InputProps) {
  const { className, error, ...restProps } = props

  let errorMessage: string | undefined

  if (typeof error != "boolean") {
    errorMessage = error?.message
  }

  return (
    <div className={twMerge([style.base, error && style.hasError])}>
      <input className={twMerge([className])} {...restProps} />
      {errorMessage && <FieldError className={style.fieldError} message={errorMessage} />}
    </div>
  )
}
